import { useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export function ThanksPage() {
  const { token } = useParams<{ token: string }>();

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Gracias</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Gracias por completar la evaluación. Puedes cerrar esta ventana.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
